import { Dialog } from "primereact/dialog";
import React from "react";
import "./style.scss";
import icon from "../../assets/images/globe.png";
import CustomeButton from "../Button";
import useCompleteProfile from "./useCompleteProfile";
import { Dropdown } from "primereact/dropdown";
import timezoneslist from "../../assets/timezone-list.json";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import TimeZoneDropdown from "../TimeZoneSelector";
const CompleteProfile = () => {
  const {
    selectTimeZone,
    setSelectTimeZone,
    timezone,
    handleAddTimezone,
    isUpateTimezone,
    handleSelectTimeZone,
    hasTimeZone,
  } = useCompleteProfile();
  return (
    <Dialog
      visible={hasTimeZone}
      className="timezone__layout--container"
      style={{ minWidth: "742px" }}
    >
      {!selectTimeZone ? (
        <>
          <div className="globe-image">
            <img src={icon} height="248px" />
          </div>
          <div className="complete__profile-container">
            <p className="heading__primary">Welcome to Gateway</p>
            <p className="text-sm m-0">
              Before we start, let's set up your account.
            </p>
            <CustomeButton
              variant="contained"
              onClick={() => setSelectTimeZone(true)}
            >
              Complete Profile
            </CustomeButton>
          </div>
        </>
      ) : (
        <>
          <div className="timezone-container">
            <p className="heading__secondary">Complete your profile</p>
            <div className="timezonte__dropdown">
              <label className="label-text">
                Timezone
                <span
                  className="info-icon ml-1 pi pi-info-circle"
                  id="given-name-info"
                />
                <Tooltip
                  target="#given-name-info"
                  content="Select your time zone for accurate scheduling and project timing."
                  position="right"
                  className="tool__tip--timezone"
                />
              </label>
              <TimeZoneDropdown
                timezones={timezoneslist}
                value={timezone}
                onChange={handleSelectTimeZone}
                disabled={false}
              />
            </div>
            <Button
              variant="contained"
              className="set-process-btn"
              onClick={handleAddTimezone}
              disabled={!timezone}
              loading={isUpateTimezone}
            >
              Complete Profile
            </Button>
          </div>
        </>
      )}
    </Dialog>
  );
};

export default CompleteProfile;
